
// Custom regel för vee-validate: kryssruta måste kryssas i. Primärt att användas för komponenten <eui-form-kryssruta>.

import { Validator } from 'vee-validate';

// https://baianat.github.io/vee-validate/guide/custom-rules.html#using-the-custom-rule:
const ruleValidator = {
	getMessage(field, args, data) {
		// will be added to default locale messages.
		// Returns a message.

		//return (data && data.message) || 'Måste väljas.';
		return (args && args[0]) || 'Måste väljas.';
	},

	validate(value, args)		// ist.f. args kan man decomposea: [otherValue]
	{
		// Returns a Boolean or a Promise that resolves to a boolean.

		//console.log('required-checked:', value, 'type === boolean:', typeof value === 'boolean', 'type === string:', typeof value === 'string');

		let valid = false;

		// Todo: Har inte lyckats tämja v-model och/eller vee-validate riktigt i detta avseende:
		// En kryssruta har ett "value" som är separerat från kryssrutans state, vilken anges av "checked".
		// v-model, likson vee-validate, arbetar som standard med "value" (och "input"-eventet), medan våra komponenter ändrar model till "boolean prop", "change" och anger "change" som event att lyssna till för vee-validate.
		// Trots det så får denna valideringsmetod *ibland* fältets .value (string, som alltid är "on" om man inte satt ngt annat) som parameter vid change-event.
		// Kan ha med initiering/updates att göra. Vissa valideringsanrop görs kanske *innan* allt kopplats rätt i Vue och vue/vee-validate vet att modellen är annorlunda???
		// Löst tills vidare genom att vi helt enkelt filtrerar bort alla valideringar av strängvärden. De åtföljs alltid (i alla fall så som eui-form-kryssruta är konstruerad) av korrekta valideringar med boolean-värden:
		if (typeof value === 'string')
		{
			// Obs! Om denna sätts till true så fallerar vee-validate. Först görs 2 st anrop hit med värde="on" följda av 2 st med rätt boolean-värde. I fallet då dessa är false hanterar vee-validate slutresultatet som valid. Det omvända funkar, dvs att vid de 2 st "on" sätta false här. Oklart varför!
			// Det verkar f.ö. vara samma beteende som om man anv standard-regeln "required:true" (ett error flimrar till kort på skärmen för att direkt försvinna. Syns bara om error-elementets vara/icke-vara resulterar i omflödning av övrigt på sidan!):
			valid = false;
		}
		else
		{
			valid = (value === true);
		}
			

		// Require-like rules
		// If you need to define a rule that declares a field as required under specific conditions, you will need to enable the computesRequired option. Because, by default, VeeValidate doesn't validate non require-like rules if the field has no value. The computesRequired will tell VeeValidate to run your rule even if the field has no value.
		// In consequence, your rule must return an object with both valid and data.required boolean properties:
		// Your rule also has to check for the requirement to be fulfilled. If data.required is set to false, the other field rules won't be executed if the field is empty.

		return {
			valid: valid,
			data: {
				required: true,	// Det finns inget "otherValue"/"hasTarget" som också måste validera.
				//data: valid ? undefined : { message: args[0] }
			}
		};
		
	}
};

//const myRule = {
//  getMessage(field, args, data) {
//      return (data && data.message) || 'Something went wrong';
//  },
//  validate(value) {
//    return new Promise(resolve => {
//      resolve({
//        valid: value === 'trigger' ? false : !! value,
//        data: value !== 'trigger' ? undefined : { message: 'Not this value' }
//      });
//    });
//  }
//};


let redanKord = false;


export default {

	runOnce() {

		if (!redanKord)
		{
			redanKord = true;

			Validator.extend('required-checked', ruleValidator, {
					computesRequired: true,
					hasTarget: false,
				}
			);
		}

	}
}
